<div class="container">
  <!-- ======== TOP ACTION BUTTONS ======== -->
  <div class="text-right mb-4">
    <!-- Clear Button -->
    <button class="btn btn-light hover-button mail " (click)="clearClick()">
      <mat-icon>clear_all</mat-icon>&nbsp; Clear
    </button>

<!-- Upload Excel Button -->
<button 
  class="btn btn-light hover-button mail" 
  (click)="fileInput.click()" 
  matTooltip="Upload Excel file here"
  matTooltipPosition="above"
>
  <mat-icon>file_upload</mat-icon>&nbsp; Upload File
</button>

<input
  type="file"
  #fileInput
  accept=".xlsx, .xls"
  (change)="uploadFile($event)"
  hidden
/>

<!-- Generate Report Button: only visible after file upload -->
<button
  *ngIf="fileUploaded"
  class="btn btn-light hover-button mail1"
  style="width: 230px;"
  (click)="createFinalReport()"
>
  <mat-icon>description</mat-icon>&nbsp; Generate Final Report
</button>



  </div>

  <div class="bgv">
    <form [formGroup]="databaseForm">
      <!-- PIC -->
      <!-- <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Customer PIC:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'PIC'" [formSubmitted]="formSubmitted"
            [errorMessage]="'Customer PIC is required'" [controlname]="databaseForm.controls['pic']">
          </app-custom-input>
        </div>
      </div> -->

      <!-- Analyst PIC -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Analyst PIC:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Analyst PIC'" [formSubmitted]="formSubmitted"
            [errorMessage]="'Analyst PIC is required'" [controlname]="databaseForm.controls['picAnalyst']">
          </app-custom-input>
        </div>
      </div>

      <!-- Clients Name -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Clients Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Clients Name'" [formSubmitted]="formSubmitted"
            [errorMessage]="'Clients Name is required'" [controlname]="databaseForm.controls['clientsName']">
          </app-custom-input>
        </div>
      </div>

      <!-- Date Received from Client -->
      <div class="row oddBgv datesBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Date Received from
            Client:</label>
        </div>
        <div class="col-md-8 textBox1">
          <div class="row">
            <div class="col-md-12">
              <app-custom-date-picker [formSubmitted]="formSubmitted"
                [errorMessage]="'Date Received from Client is required'"
                [controlname]="databaseForm.controls['dateReceivedFromClient']">
              </app-custom-date-picker>
            </div>
          </div>
        </div>
      </div>

      <!-- Vessel Name -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Vessel Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [formSubmitted]="formSubmitted" [errorMessage]="'Vessel Name is required'"
            [placeholder]="'Vessel Name'" [controlname]="databaseForm.controls['vessel']"></app-custom-input>
        </div>
      </div>

      <!-- Vessel IMO -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label><span class="asterik-color">*</span>Vessel IMO:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [formSubmitted]="formSubmitted" [errorMessage]="'Vessel IMO is required'"
            [placeholder]="'Vessel IMO'" [controlname]="databaseForm.controls['vesselIMO']"></app-custom-input>
        </div>
      </div>

      <!-- Meraki Unique Number -->
    <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
  <div class="col-md-4">
    <label>Meraki Unique Number:</label>
  </div>
  <div class="col-md-8 textBox">
    <app-custom-input
      [placeholder]="'Meraki Unique Number'"
      [controlname]="databaseForm.controls['merakiUniqueNumber']">
    </app-custom-input>

   
    <mat-icon
      class="refresh-icon"
      matTooltip="Generate Unique Number"
      (click)="generateUniqueNumber()">
      refresh
    </mat-icon>
  </div>
</div>



      <!-- Voyage Status -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Voyage Status:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Select Status'" [items]="voyageStatusOptions"
            [controlname]="databaseForm.controls['voyageRunningOrCompleted']"></app-custom-dropdown>
        </div>
      </div>

      <!-- Final Report -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Final Report:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Pending / Sent'" [items]="['Not Started', 'Sent']"
            [controlname]="databaseForm.controls['finalReportStatusSent']"></app-custom-dropdown>
        </div>
      </div>

      <!-- Final Report Sent Date -->
      <div class="row oddBgv datesBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Final Report Sent Date:</label>
        </div>
        <div class="col-md-8 textBox1">
          <div class="row">
            <div class="col-md-12">
              <app-custom-date-picker [formSubmitted]="formSubmitted"
                [controlname]="databaseForm.controls['reportSentDate']">
              </app-custom-date-picker>
            </div>
          </div>
        </div>
      </div>



      <!-- Heating Method -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Heating Method:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Select Method'" [items]="heatingMethodOptions" [controlname]="
              databaseForm.controls['heatingCoilsOrDeckHeatExchanger']
            "></app-custom-dropdown>
        </div>
      </div>

      <!-- Voyage Number -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Voyage Number:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Voyage Number'"
            [controlname]="databaseForm.controls['voyageNumber']"></app-custom-input>
        </div>
      </div>

      <!-- Cargo Name -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Cargo Name:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Cargo Name'"
            [controlname]="databaseForm.controls['cargoName']"></app-custom-input>
        </div>
      </div>

      <!-- Cargo Type -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Cargo Type:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Select Cargo Type'" [items]="cargoTypeOptions"
            [controlname]="databaseForm.controls['cargoType']"></app-custom-dropdown>
        </div>
      </div>

      <!-- Heating Instructions -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Heating Instructions:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Heating Instructions'"
            [controlname]="databaseForm.controls['heatingInstructions']"></app-custom-input>
        </div>
      </div>

      <!-- Average Load Temp -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Average Load Temp (°C):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Load Temp'"
            [controlname]="databaseForm.controls['averageLoadedCargoTempDegC']"></app-custom-input>
        </div>
      </div>

      <!-- Average Discharge Temp -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Average Discharge Temp (°C):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Discharge Temp'"
            [controlname]="databaseForm.controls['averageDischCargoTempDegC']"></app-custom-input>
        </div>
      </div>

      <!-- Estimated Consumption -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Estimated Consumption (MT):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Estimated Consumption'" [controlname]="
              databaseForm.controls['merakiTotalEstimatedHeatingConsumptionsMT']
            "></app-custom-input>
        </div>
      </div>

      <!-- Total Heating Consumption -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Total Heating Consumption (MT):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Total Heating Consumption'" [controlname]="
              databaseForm.controls['totalHeatingBunkerConsumptionMT']
            "></app-custom-input>
        </div>
      </div>

      <!-- AE Consumption for Boiler -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>AE Consumption - Boiler Operation (MT):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'AE Consumption'" [controlname]="
              databaseForm.controls['aeConsumptionForBoilerOperationMT']
            "></app-custom-input>
        </div>
      </div>

      <!-- Deck Heat Exchanger Bunker Consumption -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Deck Heat Exchanger Bunker Consumption (MT):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Deck Heat Exchanger Consumption'" [controlname]="
              databaseForm.controls['deckHeatExchangerBunkerConsumptionMT']
            "></app-custom-input>
        </div>
      </div>

      <!-- Total Bunker Consumption -->
      <div class="row oddBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
        <div class="col-md-4">
          <label>Total Bunker Consumption (MT):</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-input [placeholder]="'Total Bunker Consumption'"
            [controlname]="databaseForm.controls['totalBunkerConsumptionMT']"></app-custom-input>
        </div>
      </div>

      <!-- Heating Log Analysis Entry -->
      <div class="row fevenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
        <div class="col-md-4">
          <label>Heating Log Analysis Entry:</label>
        </div>
        <div class="col-md-8 textBox">
          <app-custom-dropdown [placeholder]="'Yes / No'" [items]="heatingLogEntryOptions"
            [controlname]="databaseForm.controls['heatingLogAnalysisEntry']"></app-custom-dropdown>
        </div>
      </div>
      <div formArrayName="loadPortDetails">
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }"
          *ngFor="let group of loadPortDetails.controls; let i = index" [formGroupName]="i">
          <div class="col-md-4">
            <label>Load Ports :</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-5">
                <label class="repotedWeatherLabel">Load Port {{ i + 1 }}</label>
                <input type="text" class="form-control" placeholder="Enter Load Port" formControlName="loadPort" />
              </div>
              <div class="col-md-5">
                <label class="repotedWeatherLabel">Departure Time {{ i + 1 }}</label>
                <input type="date" class="form-control" formControlName="departure" />

              </div>

              <div class="addIcon">
                <mat-icon class="add-icon" *ngIf="
                    i === loadPortDetails.length - 1
                  " (click)="addLoadPortRow()" matTooltip="Add Load Port">add_circle_outline</mat-icon>

                <mat-icon class="remove-icon" *ngIf="loadPortDetails.length > 1" (click)="removeLoadPortRow(i)"
                  matTooltip="Remove Load Port">remove_circle_outline</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div formArrayName="dischargePortDetails">
        <div class="row evenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }"
          *ngFor="let group of dischargePortDetails.controls; let i = index" [formGroupName]="i">
          <div class="col-md-4">
            <label>Discharge Ports :</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-5">
                <label class="repotedWeatherLabel">Discharge Port {{ i + 1 }}</label>
                <input type="text" class="form-control" placeholder="Enter Discharge Port"
                  formControlName="dischargePort" />
              </div>
              <div class="col-md-5">
                <label class="repotedWeatherLabel">Arrival Time {{ i + 1 }}</label>
                <input type="date" class="form-control" placeholder="Enter Arrival" formControlName="arrival" />
              </div>

              <div class="addIcon">
                <mat-icon class="add-icon" *ngIf="
                    i === dischargePortDetails.length - 1
                  " (click)="addDischargePortRow()" matTooltip="Add Discharge Port">add_circle_outline</mat-icon>

                <mat-icon class="remove-icon" *ngIf="dischargePortDetails.length > 1"
                  (click)="removeDischargePortRow(i)"
                  matTooltip="Remove Discharge Port">remove_circle_outline</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
<!-- Load Ports (ESM) -->
<div formArrayName="loadPorts">
  <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }"
       *ngFor="let group of loadPorts.controls; let i = index" [formGroupName]="i">
    
    <div class="col-md-4">
      <label>Load Ports (ESM):</label>
    </div>

    <div class="col-md-8 textBox">
      <div class="row">
        <!-- Port Name -->
        <div class="col-md-3">
          <label>Port {{ i + 1 }} Name</label>
          <input type="text" class="form-control" placeholder="Enter Port Name" formControlName="port_name" />
        </div>

        <!-- Events -->
        <div class="col-md-9" formGroupName="events">
          <div class="row">
            <div class="col-md-4">
              <label>EOSP</label>
              <input type="datetime-local" class="form-control" formControlName="eosp" />
            </div>
            <div class="col-md-4">
              <label>All Fast</label>
              <input type="datetime-local" class="form-control" formControlName="all_fast" />
            </div>
            <div class="col-md-4">
              <label>COSP</label>
              <input type="datetime-local" class="form-control" formControlName="cosp" />
            </div>
          </div>
        </div>

        <div class="addIcon">
          <mat-icon
            class="add-icon"
            *ngIf="i === loadPorts.length - 1"
            (click)="addLoadPortEventRow()"
            matTooltip="Add Load Port (ESM)">
            add_circle_outline
          </mat-icon>

          <mat-icon
            class="remove-icon"
            *ngIf="loadPorts.length > 1"
            (click)="removeLoadPortEventRow(i)"
            matTooltip="Remove Load Port (ESM)">
            remove_circle_outline
          </mat-icon>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Discharge Ports -->
<div formArrayName="dischargePorts">
  <div class="row evenBgv" [ngClass]="{ 'dark-odd': isDarkMode() }"
       *ngFor="let group of dischargePorts.controls; let i = index" [formGroupName]="i">
    
    <div class="col-md-4">
      <label>Discharge Ports (ESM):</label>
    </div>

    <div class="col-md-8 textBox">
      <div class="row">
        <!-- Port Name -->
        <div class="col-md-3">
          <label>Port {{ i + 1 }} Name</label>
          <input type="text" class="form-control" placeholder="Enter Port Name" formControlName="port_name" />
        </div>

        <!-- Events -->
        <div class="col-md-9" formGroupName="events">
          <div class="row">
            <div class="col-md-4">
              <label>EOSP</label>
              <input type="datetime-local" class="form-control" formControlName="eosp" />
            </div>
            <div class="col-md-4">
              <label>All Fast</label>
              <input type="datetime-local" class="form-control" formControlName="all_fast" />
            </div>
            <div class="col-md-4">
              <label>COSP</label>
              <input type="datetime-local" class="form-control" formControlName="cosp" />
            </div>
          </div>
        </div>

        <!-- Add / Remove Icons -->
        <div class="addIcon">
          <mat-icon
            class="add-icon"
            *ngIf="i === dischargePorts.length - 1"
            (click)="addDischargePortEventRow()"
            matTooltip="Add Discharge Port (ESM)">
            add_circle_outline
          </mat-icon>

          <mat-icon
            class="remove-icon"
            *ngIf="dischargePorts.length > 1"
            (click)="removeDischargePortEventRow(i)"
            matTooltip="Remove Discharge Port (ESM)">
            remove_circle_outline
          </mat-icon>
        </div>

      </div>
    </div>
  </div>
</div>


      <!-- Load Port and Discharge Port sections would be appended here as dynamic arrays -->
    </form>
  </div>
      <div class="text-right mb-4">
    <!-- Clear Button -->
    <button class="btn btn-light hover-button mail " (click)="clearClick()">
      <mat-icon>clear_all</mat-icon>&nbsp; Clear
    </button>

<!-- Upload Excel Button -->
<button 
  class="btn btn-light hover-button mail" 
  (click)="fileInput.click()" 
  matTooltip="Upload Excel file here"
  matTooltipPosition="above"
>
  <mat-icon>file_upload</mat-icon>&nbsp; Upload File
</button>

<input
  type="file"
  #fileInput
  accept=".xlsx, .xls"
  (change)="uploadFile($event)"
  hidden
/>

<!-- Generate Report Button: only visible after file upload -->
<button
  *ngIf="fileUploaded"
  class="btn btn-light hover-button mail1"
  style="width: 230px;"
  (click)="createFinalReport()"
>
  <mat-icon>description</mat-icon>&nbsp; Generate Final Report
</button>



  </div>
  <br>
  <br>
</div>
